import { ALGO_SESSION_WRAPPER_KEY, APPNAME, APPVER, APP_SOURCE, APP_SOURCETRADESTATION, MARGIN_PASSWORD, MARGIN_USERID, OSNAME, advisoryToken, APP_SOURCE_SEGMENT_API, ANALYTICS_API_AUTHORIZATION, ELASTIC_SEARCH_ORDEBY_VALUE, } from "./../utils/constant";
import { SESSION_KEYS, getDataFromSession } from "src/utils/session-storage";
import { encrypt, generateRandomRemoteId, getJwtToken } from "../utils/methods";
import { ApiClient } from "../config/axios";
import { Apis } from ".";
import { getMarketStatusDummyData } from "./mock/data/get-market-status";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { getSmartApiKeyFromLocalStorage } from "src/utils/smart-algo-login";
const { REACT_APP_GATEWAY_5PEACCOUNT_TOKEN, REACT_APP_API_HEADER_KEY, REACT_APP_API_HEADER_KEY2, REACT_APP_GATEWAY_CRM_KEY, REACT_APP_TRADE_API_GATEWAY_KEY2, REACT_APP_TRADE_API_GATEWAY_KEY, REACT_APP_ONELOGIN_TOKEN_CLIENT_ID, REACT_APP_ONELOGIN_TOKEN_CLIENT_SECRET, REACT_APP_MARGIN_API_GATEWAY_KEY, REACT_APP_IIFL_AUTHSERVICE_KEY, REACT_APP_SOURCE_APP_HOLDING, REACT_APP_API_MARKETDATA_OCP_KEY, REACT_APP_API_MARKETDATA_KEY, REACT_APP_API_USER_ID1, REACT_APP_API_PASSWORD1, REACT_APP_SWARAJCORE_API_GATEWAY_KEY2, REACT_APP_API_NEW_USER_ID, REACT_APP_API_NEW_PASSWORD, REACT_APP_ACTIVATE_SEGMENT_KEY, } = process.env;
const head = {
    appName: APPNAME,
    appSource: APP_SOURCE,
    appVer: APPVER,
    osName: OSNAME,
    key: REACT_APP_API_HEADER_KEY || "",
    // key: "8eeee59bdab88bace6189d001f96487e",
};
// const marketDepthToken =
//   getDataFromSession(SESSION_KEYS.MARKETDEPTHTOKEN) || "";
export const getExpiryFromSymbol = (symbol, exchange) => {
    return ApiClient.post(Apis["get-expiry"].endpoint, {
        head: Object.assign(Object.assign({}, head), { requestCode: "5PJanGEFSOV2" }),
        body: {
            Exch: exchange,
            Symbol: symbol,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            // "Ocp-Apim-Subscription-Key": "a4af51382266497bb5464d95fbb2017b" || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const analyticsAPIClickhouse = (data) => {
    return ApiClient.post(Apis["analytics-clickhouse"].endpoint, {
        eventData: data,
    }, {
        headers: {
            Authorization: ANALYTICS_API_AUTHORIZATION,
        },
    });
};
export const getOptionsFromSymbol = (symbol, expiry, exchange) => {
    const expirySplit1 = expiry === null || expiry === void 0 ? void 0 : expiry.split("+")[0];
    const expirySplit2 = expiry === null || expiry === void 0 ? void 0 : expiry.split("+")[1];
    const timezoneSplit2 = expirySplit2 === null || expirySplit2 === void 0 ? void 0 : expirySplit2.split(")")[1];
    const formattedExpiry = `${expirySplit1})` + timezoneSplit2;
    return ApiClient.post(Apis["get-options"].endpoint, {
        head: Object.assign(Object.assign({}, head), { requestCode: "5PJanGOFS" }),
        body: {
            Exch: exchange,
            Symbol: symbol,
            ExpiryDate: formattedExpiry,
            //ExpiryDate: expiry,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            // "Ocp-Apim-Subscription-Key": "a4af51382266497bb5464d95fbb2017b" || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const GetOptionchainList = (symbol, exch, exchType, signal) => {
    return ApiClient.get(Apis["get-option-chain-list"].endpoint(symbol, exch), Object.assign({ headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            // "Ocp-Apim-Subscription-Key": "a4af51382266497bb5464d95fbb2017b" || "",
            Authorization: `Bearer ${getJwtToken()}`,
            UserID: "ZyT47UW2g56",
            Password: "H98qlU4Sn2",
        } }, signal));
};
export const GetOptionchainListV2 = (symbol, type) => {
    return ApiClient.get(Apis["get-option-chain-list"].endpoint(symbol, type), {
        headers: {
            // "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            // "Ocp-Apim-Subscription-Key": "a4af51382266497bb5464d95fbb2017b" || "",
            // Authorization: `Bearer ${getJwtToken()}`,
            Username: "indiainfolineiiflweb",
            Password: "Glaxo@123",
        },
    });
};
export const GetOptionchainForSymbol = (symbol, exch, exchType, expiry, signal) => {
    return ApiClient.get(Apis["get-option-for-symbol"].endpoint(symbol, expiry, exch, exchType), Object.assign({ headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            // "Ocp-Apim-Subscription-Key": "a4af51382266497bb5464d95fbb2017b" || "",
            Authorization: `Bearer ${getJwtToken()}`,
            // Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6IjUwNzYxODU2Iiwicm9sZSI6IjEiLCJuYmYiOjE3MTY0NjM5MDAsImV4cCI6MTcxOTA1NTkwMCwiaWF0IjoxNzE2NDYzOTAwfQ.Osikvnmin_aYAZfNZ2LWrDdj6KEGzlY7DbzNiLhTJ6U`,
            UserID: "ZyT47UW2g56",
            Password: "H98qlU4Sn2",
        } }, signal));
};
export const getFNOScripts = (symbol) => {
    return ApiClient.get(Apis["get-fno-scripts"].endpoint(symbol), {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            // "Ocp-Apim-Subscription-Key": "a4af51382266497bb5464d95fbb2017b" || "",
            Authorization: `Bearer ${getJwtToken()}`,
            // Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6IjUwNzYxODU2Iiwicm9sZSI6IjEiLCJuYmYiOjE3MTY0NjM5MDAsImV4cCI6MTcxOTA1NTkwMCwiaWF0IjoxNzE2NDYzOTAwfQ.Osikvnmin_aYAZfNZ2LWrDdj6KEGzlY7DbzNiLhTJ6U`,
        },
    });
};
export const getFNOScriptsAndIndex = () => {
    return ApiClient.get(Apis["get-fno-scripts-and-index"].endpoint, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            // "Ocp-Apim-Subscription-Key": "a4af51382266497bb5464d95fbb2017b" || "",
            Authorization: `Bearer ${getJwtToken()}`,
            //Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6IjUwNzYxODU2Iiwicm9sZSI6IjEiLCJuYmYiOjE3MTY0NjM5MDAsImV4cCI6MTcxOTA1NTkwMCwiaWF0IjoxNzE2NDYzOTAwfQ.Osikvnmin_aYAZfNZ2LWrDdj6KEGzlY7DbzNiLhTJ6U`,
        },
    });
};
export const getMargin = (signal) => {
    return ApiClient.post(Apis["get-margin"].endpoint, {
        head: {
            appName: APPNAME,
            appVer: APPVER,
            osName: OSNAME,
            key: REACT_APP_API_HEADER_KEY || "",
            requestCode: "5PMarginV10",
        },
        body: {
            ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
        },
    }, Object.assign({ headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            // "Ocp-Apim-Subscription-Key": "a4af51382266497bb5464d95fbb2017b" || "",
            Authorization: `Bearer ${getJwtToken()}`,
        } }, signal));
};
export const getOptionsGreeks = () => {
    return ApiClient.post(Apis["get-option-greeks"].endpoint, {
        head: {
            appName: APPNAME,
            appVer: APPVER,
            osName: OSNAME,
            key: REACT_APP_API_HEADER_KEY || "",
            requestCode: "OptionsGreek",
        },
        body: {
            ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
            //getDataFromSession(SESSION_KEYS.CLIENT_CODE),,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            // "Ocp-Apim-Subscription-Key": "a4af51382266497bb5464d95fbb2017b" || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const setPreferencesApi = (value, clientCode) => {
    return ApiClient.post(Apis["set-derivatives-preference"].endpoint(clientCode), {
        derivative: value,
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            access_token: getJwtToken(),
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
// get preference api for derivative
// do not need jwtToken as access_token's values
export const getPreferenceApi = (clientCode) => {
    return ApiClient.get(Apis["get-derivatives-preference"].endpoint(clientCode), {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            access_token: getJwtToken(),
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getBaskets = () => {
    return ApiClient.post(Apis["get-basket"].endpoint, {
        head: Object.assign(Object.assign({}, head), { requestCode: "5PGB" }),
        body: { ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE) },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getWatchlistList = () => {
    return ApiClient.post(Apis["get-watchlist-list"].endpoint, {
        head: Object.assign(Object.assign({}, head), { requestCode: "5PDecGMWRVMW3" }),
        body: { ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE) },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const searchFOScrip = (symbol, signal) => {
    return ApiClient.post(Apis["search-fo-scrip"].endpoint, {
        Symbol: symbol,
        DerivativeType: "F",
    }, Object.assign({ headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        } }, signal));
};
export const scriptDetailsForFOOrder = (exchange, exchangeType, scripCode) => {
    return ApiClient.post(Apis["scrip-details-fo-order-v6"].endpoint, {
        Exch: exchange,
        ExchType: exchangeType,
        ScripCode: scripCode,
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_API_HEADER_KEY2 || "",
            Authorization: `Bearer ${getJwtToken()}`,
            UserID: "ZyT47UW2g56",
            Password: "H98qlU4Sn2",
        },
    });
};
export const scriptDetailsForFOOrderV4 = (exchange, exchangeType, scripCode) => {
    return ApiClient.post(Apis["scrip-details-fo-order-v4"].endpoint, {
        Exch: exchange,
        ExchType: exchangeType,
        ScripCode: scripCode,
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const preOrdMarginCalculation = (clientCode, exchange, exchangeType, scripCode, orderType, transactionType, priceType, price, quantity, productType) => {
    return ApiClient.post(Apis["margin-calculation"].endpoint, {
        head: {
            appName: APPNAME,
            appVer: APPVER,
            key: REACT_APP_API_HEADER_KEY || "",
            osName: OSNAME,
            requestCode: "5PPreOrdMarCal",
        },
        body: {
            OrderRequestorCode: clientCode,
            Exch: exchange,
            ExchType: exchangeType,
            ClientCode: clientCode,
            ScripCode: scripCode,
            PlaceModifyCancel: orderType,
            TransactionType: transactionType,
            AtMarket: priceType,
            LimitRate: price,
            Volume: quantity,
            OldTradedQty: "0",
            ProductType: productType,
            ExchOrderId: "0",
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const createOrderRequest = (clientCode, exchange, exchangeType, scripCode, transactionType, atMarket, price, quantity, exchangeOrderId, disclosedQuantity, isStopLoss, stopLossPrice, isVtd, isIoc, isIntraDay, afterMarketHours, validityTime, orderFor, iOrderValidity, brokerOrderId, TradedQty) => {
    const reqJson = {
        head: {
            appName: APPNAME,
            appVer: APPVER,
            appSource: APP_SOURCE,
            key: REACT_APP_API_HEADER_KEY || "",
            osName: OSNAME,
            requestCode: "5POrdReqV3",
        },
        body: {
            OrderRequesterCode: clientCode,
            Exchange: exchange,
            ExchangeType: exchangeType,
            ClientCode: clientCode,
            ScripCode: scripCode,
            OrderType: transactionType,
            AtMarket: atMarket,
            Price: price,
            Qty: quantity,
            ExchOrderID: exchangeOrderId,
            OrderFor: orderFor,
            OrderID: 4,
            TradedQty: TradedQty,
            OrderDateTime: new Date().getTime(),
            RemoteOrderID: generateRandomRemoteId(),
            DisQty: disclosedQuantity,
            IsStopLossOrder: isStopLoss,
            StopLossPrice: stopLossPrice,
            IsVTD: isVtd,
            IOCOrder: isIoc,
            IsIntraday: isIntraDay,
            PublicIP: "",
            AHPlaced: afterMarketHours,
            ValidTillDate: validityTime,
            iOrderValidity: iOrderValidity,
            AppSource: APP_SOURCE,
            BrokerOrderId: brokerOrderId,
        },
    };
    return ApiClient.post(Apis["create-order-request"].endpoint, reqJson, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const createBulkOrderRequest = (requestBody) => {
    const reqJson = {
        head: {
            appName: APPNAME,
            appVer: APPVER,
            appSource: APP_SOURCE,
            key: REACT_APP_API_HEADER_KEY || "",
            osName: OSNAME,
            requestCode: "5POrdReqV3",
        },
        body: requestBody,
    };
    return ApiClient.post(Apis["order-request-bulk"].endpoint, reqJson, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const createSmoOrderRequest = (clientCode, exchange, exchangeType, scripCode, transactionType, atMarket, price, quantity, exchangeOrderId, disclosedQuantity, stopLossPrice, afterMarketHours, requestType, orderFor, targetPrice, stopLossTriggerPrice, trailingStopLoss) => {
    const reqJson = {
        head: {
            appName: APPNAME,
            appVer: APPVER,
            key: REACT_APP_API_HEADER_KEY || "",
            osName: OSNAME,
            requestCode: "5PSMOOrdV2",
        },
        body: {
            OrderRequesterCode: clientCode,
            Exch: exchange,
            ExchType: exchangeType,
            ClientCode: clientCode,
            ScripCode: scripCode,
            BuySell: transactionType,
            AtMarket: atMarket,
            LimitPriceInitialOrder: price,
            TriggerPriceInitialOrder: "0.00",
            LimitPriceProfitOrder: targetPrice,
            Qty: quantity,
            ExchOrderId: exchangeOrderId,
            RequestType: requestType,
            OrderFor: orderFor,
            TradedQty: "0",
            DisQty: disclosedQuantity,
            LimitPriceForSL: stopLossPrice,
            TriggerPriceForSL: stopLossTriggerPrice,
            TrailingSL: trailingStopLoss,
            StopLoss: true,
            PublicIP: "",
            AHPlaced: afterMarketHours,
            AppSource: APP_SOURCE,
            UniqueOrderIDNormal: "2022053112581216",
            UniqueOrderIDSL: "2022053112581217",
            UniqueOrderIDLimit: "2022053112581218",
            LocalOrderIDNormal: 16,
            LocalOrderIDSL: 17,
            LocalOrderIDLimit: 18,
        },
    };
    return ApiClient.post(Apis["create-smo-order"].endpoint, reqJson, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const modifySmoOrderRequest = (orderId, exchangeOrderId, clientCode, exchange, exchangeType, scripCode, atMarket, price, quantity, disclosedQuantity, afterMarketHours, delVintra, //C-cover , B - bracket
trailingStopLoss, stopLossPrice, isStopLoss) => {
    const reqJson = {
        head: {
            appName: APPNAME,
            appVer: APPVER,
            key: REACT_APP_API_HEADER_KEY || "",
            osName: OSNAME,
            requestCode: "5PSModMOOrdV1",
        },
        body: {
            OrderRequesterCode: clientCode,
            Exchange: exchange,
            ExchangeType: exchangeType,
            ClientCode: clientCode,
            ScripCode: scripCode,
            AtMarket: atMarket,
            Qty: quantity,
            OrderFor: "M",
            TradedQty: "0",
            DisQty: disclosedQuantity,
            TrailingSL: trailingStopLoss,
            PublicIP: "",
            AHPlaced: afterMarketHours,
            AppSource: APP_SOURCE,
            Price: price,
            OrderID: orderId,
            OrderType: delVintra,
            OrderDateTime: new Date().getTime(),
            RemoteOrderID: generateRandomRemoteId(),
            ExchOrderID: exchangeOrderId,
            StopLossPrice: stopLossPrice,
            IsStopLossOrder: isStopLoss,
            IOCOrder: false,
            IsIntraday: true,
            ISVTD: false,
            iOrderValidity: 0,
            LegType: "0",
            TMOPartnerOrderID: "0",
        },
    };
    return ApiClient.post(Apis["modify-smo-order"].endpoint, reqJson, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getVttOrderbook = (signal) => {
    return ApiClient.post(Apis["get-vtt-orderbook"].endpoint, {
        head: Object.assign(Object.assign({}, head), { requestCode: "5PGetVTTO" }),
        body: {
            ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
            //getDataFromSession(SESSION_KEYS.CLIENT_CODE),,
        },
    }, Object.assign({ headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        } }, signal));
};
export const getScreener = (gainerOrLooserFlag, unknown2, unknown3) => {
    return ApiClient.get(Apis["get-screener"].endpoint(gainerOrLooserFlag, unknown2, unknown3), {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            // Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const futureDashboardApi = (expiryType) => {
    return ApiClient.get(Apis["future-dashboard"].endpoint(expiryType), {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            // Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const optionDashboardApi = (expiryType, categoryType) => {
    return ApiClient.get(Apis["option-dashboard"].endpoint(expiryType), {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            // Authorization: `Bearer ${getJwtToken()}`,
        },
        params: {
            category: categoryType,
        },
    });
};
export const futureTrendApi = (expiryType, categoryType) => {
    return ApiClient.get(Apis["future-trend"].endpoint(expiryType, categoryType), {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            // Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const optionTrendApi = (expiry, activity, callType, categoryType) => {
    return ApiClient.get(Apis["option-trend"].endpoint(expiry, activity), {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            // Authorization: `Bearer ${getJwtToken()}`,
        },
        params: {
            instrumentType: callType == "all" ? "" : callType,
            category: categoryType,
        },
    });
};
export const getNetPositionNetWiseData = () => {
    return ApiClient.post(Apis["get-net-position-net-wise"].endpoint, {
        head: Object.assign(Object.assign({}, head), { requestCode: "5PNPNWV2" }),
        body: {
            ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
            // getDataFromSession(SESSION_KEYS.CLIENT_CODE),,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getDayNetPositionData = () => {
    return ApiClient.post(Apis["get-net-position"].endpoint, {
        head: Object.assign(Object.assign({}, head), { requestCode: "5PNetPositionV4" }),
        body: {
            ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const postConvertPosition = (body) => {
    return ApiClient.post(Apis["post-convert-position"].endpoint, {
        head: Object.assign(Object.assign({}, head), { requestCode: "5PPosConMob" }),
        body: body,
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getIndexPCR = (symbol, fromPredefined) => {
    const endpoint = fromPredefined ? "opt" : "fut";
    return ApiClient.get(Apis["get-index-pcr"].endpoint(symbol, endpoint), {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getIndexPCRRatio = (unknownType, valueType, date, symbol, unknownType1) => {
    return ApiClient.get(Apis["get-index-pcr-ratio"].endpoint(unknownType, valueType, date, symbol, unknownType1), {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
        },
    });
};
export const getNews = (startDate, endDate) => {
    return ApiClient.post(Apis["get-news"].endpoint, {
        head: Object.assign(Object.assign({}, head), { requestCode: "5PGN" }),
        body: {
            Category: "",
            Symbol: "",
            StartDate: startDate,
            EndDate: endDate,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getCorporate = () => {
    return ApiClient.get(Apis["get-corporate"].endpoint, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            // Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getWatchlist = (watchlistName) => {
    return ApiClient.post(Apis["get-watchlist"].endpoint, {
        Clientcode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
        //getDataFromSession(SESSION_KEYS.CLIENT_CODE),,
        MWName: watchlistName,
        ClientLoginType: 1,
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getDataFromAccessToken = (accessToken) => {
    return ApiClient.post(Apis["access-token-validation"].endpoint, {
        head: {
            appName: "CommonAPI",
            osName: OSNAME,
            appVersion: APPVER,
            clientIP: "::1",
        },
        body: {
            accessToken: accessToken || "",
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_GATEWAY_5PEACCOUNT_TOKEN || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getSliceLimit = (exch, exchType, scripCode) => {
    return ApiClient.post(Apis["get-slice-limit"].endpoint, {
        head: {
            appName: APPNAME,
            appSource: APP_SOURCE,
            appVer: APPVER,
            key: REACT_APP_API_HEADER_KEY || "",
            osName: OSNAME,
            requestCode: "5PRQCheckIsSliceEnable",
        },
        body: {
            Exch: exch,
            ExchType: exchType,
            ScripCode: scripCode,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const createVttOrder = (reqJson) => {
    return ApiClient.post(Apis["create-vtt-order"].endpoint, {
        head: {
            appName: APPNAME,
            appVer: APPVER,
            osName: OSNAME,
            key: REACT_APP_API_HEADER_KEY || "",
            requestCode: "5PAddVTTO",
        },
        body: {
            ClientCode: reqJson.clientCode,
            Exch: reqJson.exchange,
            ExchType: reqJson.exchangeType,
            ScripCode: reqJson.scripCode,
            InitialLimitPrice: reqJson.price,
            StopLossLimitPrice: reqJson.stopLossPrice,
            InitialTriggerPrice: reqJson.initialTriggerPrice,
            StopLossTriggerPrice: reqJson.stopLossTriggerPrice,
            ProfitLimitPrice: reqJson.profitLimitPrice,
            ProfitTriggerPrice: reqJson.profitTriggerPrice,
            Quantity: reqJson.quantity,
            BuySell: reqJson.buySell,
            MatchingCondition: reqJson.matchingCondition,
            Symbol: "", //reqJson.symbol,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const modifyVttOrder = (reqJson) => {
    return ApiClient.post(Apis["modify-vtt-orderbook"].endpoint, {
        head: {
            appName: APPNAME,
            appVer: APPVER,
            osName: OSNAME,
            key: REACT_APP_API_HEADER_KEY || "",
            requestCode: "5PModifyVTTO",
        },
        body: {
            ClientCode: reqJson.clientCode,
            VTTOrderId: reqJson.orderId,
            InitialLimitPrice: reqJson.price,
            StopLossLimitPrice: reqJson.stopLossPrice,
            InitialTriggerPrice: reqJson.initialTriggerPrice,
            StopLossTriggerPrice: reqJson.stopLossTriggerPrice,
            ProfitLimitPrice: reqJson.profitLimitPrice,
            ProfitTriggerPrice: reqJson.profitTriggerPrice,
            Qty: reqJson.quantity,
            MatchingCondition: reqJson.matchingCondition,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getFiidii = (signal) => {
    return ApiClient.get(Apis["get-fiidii"].endpoint, Object.assign({ 
        // headers: {
        //   KEY: "5260c06e20fb53c4521b8cf1f2eb0ba616634e44",
        //   requestCode: "pearlapi",
        //   UserId: "5PAISAAPI",
        //   password: "5nadynsiitnienny",
        // },
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            // Authorization: `Bearer ${getJwtToken()}`,
        } }, signal));
};
export const executeOrderApiCDSL = (Isin, Qty) => {
    return ApiClient.post(Apis["marginuser-CDSL-authorization"].endpoint, {
        head: {
            appName: APPNAME,
            appVer: APPVER,
            osName: OSNAME,
            key: REACT_APP_API_HEADER_KEY || "",
            requestCode: "5PPostDataToCDSLMF",
        },
        body: {
            ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
            //getDataFromSession(SESSION_KEYS.CLIENT_CODE),,
            IPaddress: "172.26.20.66",
            SourceApp: "6",
            isindtls: [
                {
                    ISIN: Isin || "",
                    Quantity: Qty || "",
                },
            ],
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_MARGIN_API_GATEWAY_KEY || "",
        },
    });
};
export const getPledgeMarginFund = () => {
    return ApiClient.post(Apis["pledge-margin-funding"].endpoint, {
        head: {
            appName: APPNAME,
            appVer: APPVER,
            key: REACT_APP_API_HEADER_KEY,
            osName: OSNAME,
            requestCode: "5PPledgeMarginFunding",
        },
        body: {
            ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
            //getDataFromSession(SESSION_KEYS.CLIENT_CODE),,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_MARGIN_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getRealTimeHolding = () => {
    return ApiClient.post(Apis["get-realtime-holding"].endpoint, {
        head: {
            appName: APPNAME,
            appSource: APP_SOURCE,
            appVer: APPVER,
            key: REACT_APP_API_HEADER_KEY || "",
            osName: OSNAME,
            requestCode: "5PGRTHV1",
        },
        body: {
            ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
            //getDataFromSession(SESSION_KEYS.CLIENT_CODE),,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_MARGIN_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getRealTimeHoldingV2 = () => {
    return ApiClient.post(Apis["get-realtime-holdingV2"].endpoint, {
        head: {
            appName: APPNAME,
            appSource: APP_SOURCE,
            appVer: APPVER,
            key: REACT_APP_API_HEADER_KEY || "",
            osName: OSNAME,
            requestCode: "5PGRTHV2",
        },
        body: {
            ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
            //getDataFromSession(SESSION_KEYS.CLIENT_CODE),,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_SWARAJCORE_API_GATEWAY_KEY2 || "",
            userid: REACT_APP_API_NEW_USER_ID,
            password: REACT_APP_API_NEW_PASSWORD,
        },
    });
};
export const getMarketFeedV6 = (body, signal) => {
    return ApiClient.post(Apis["get-mf-v6"].endpoint, {
        head: Object.assign(Object.assign({}, head), {
            osName: OSNAME,
            requestCode: "5PMF6",
        }),
        body: body,
    }, Object.assign({ headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        } }, signal));
};
export const getOrderInBasket = (basketId) => {
    return ApiClient.post(Apis["get-order-in-basket"].endpoint, {
        head: Object.assign(Object.assign({}, head), {
            osName: OSNAME,
            requestCode: "5PGetOIB",
        }),
        body: {
            ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
            //getDataFromSession(SESSION_KEYS.CLIENT_CODE),,
            BasketId: basketId,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getScreenerData = () => {
    return ApiClient.post(Apis["get-screener-data"].endpoint);
};
// export const getIndices = (
//   clientCode: string,
//   signal?: object
// ): Promise<any> => {
//   return ApiClient.post(
//     Apis["get-indices"].endpoint,
//     {
//       head: {
//         appName: APPNAME,
//         appVer: APPVER,
//         osName: OSNAME,
//         key: REACT_APP_API_HEADER_KEY || "",
//         requestCode: "5PGetInd",
//       },
//       body: { ClientCode: clientCode },
//     },
//     {
//       headers: {
//         "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
//         Authorization: `Bearer ${getJwtToken()}`,
//       },
//       ...signal,
//     }
//   );
// };
export const getIndices = () => {
    return ApiClient.get(Apis["get-indices"].endpoint, {
        headers: {
            // "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Basic aW5kaWFpbmZvbGluZVxpaWZsd2ViOkdsYXhvQDEyMw==`,
        },
    });
};
export const setIndices = () => {
    return ApiClient.post(Apis["set-indices"].endpoint, null, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
//To be continued
// export const setPreferences = (value: any): any => {
//   return ApiClient.post(Apis["set-preferences"].endpoint, null, {
//     headers: {
//       "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
//       Authorization: `Bearer ${getJwtToken()}`,
//     },
//   });
// };
export const getCandleStickTechnicalAnalysis = (timeRange, symbol) => {
    return ApiClient.get(Apis["get-candlestick-technical-analysis"].endpoint(timeRange), {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            // Authorization: `Bearer ${getJwtToken()}`,
        },
        params: { symbols: symbol },
    });
};
export const login = (emailId, password, dob) => {
    return ApiClient.post(Apis["login"].endpoint, {
        head: {
            appName: APPNAME,
            appVer: APPVER,
            key: REACT_APP_API_HEADER_KEY || "",
            osName: OSNAME,
            requestCode: "5PLoginV5",
        },
        body: {
            Email_id: emailId,
            Password: password,
            LocalIP: "192.168.88.41",
            PublicIP: "10.67.110.50",
            HDSerailNumber: "",
            MACAddress: "",
            MachineID: "a08f787b4a3c5037",
            VersionNo: "3.1",
            RequestNo: "1",
            My2PIN: dob,
            ConnectionType: "1",
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const checkLogin = () => {
    return ApiClient.post(Apis["check-login"].endpoint, {
        head: {
            appName: APPNAME,
            appSource: APP_SOURCE,
            appVer: APPVER,
            key: REACT_APP_API_HEADER_KEY || "",
            osName: OSNAME,
            requestCode: "5PCLRes",
        },
        body: {},
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            // "Ocp-Apim-Subscription-Key": "a8ed3b7ead504fa8903d9c7e0d23bc61" || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
        withCredentials: true,
    });
};
export const createBasket = (basketname) => {
    return ApiClient.post(Apis["create-basket"].endpoint, {
        head: {
            appName: APPNAME,
            appVer: APPVER,
            osName: OSNAME,
            key: REACT_APP_API_HEADER_KEY || "",
            requestCode: "5PCreateBSKT",
        },
        body: {
            ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
            //getDataFromSession(SESSION_KEYS.CLIENT_CODE),,
            BasketName: basketname,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getOrderBook = () => {
    return ApiClient.post(Apis["get-order-book"].endpoint, {
        head: {
            appName: APPNAME,
            appVer: APPVER,
            osName: OSNAME,
            key: REACT_APP_API_HEADER_KEY || "",
            requestCode: "5POrdBkV4",
        },
        body: {
            ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
            //getDataFromSession(SESSION_KEYS.CLIENT_CODE),,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_API_HEADER_KEY2,
            UserID: "ZyT47UW2g56",
            Password: "H98qlU4Sn2",
        },
    });
};
export const getTradeBook = () => {
    return ApiClient.post(Apis["get-trade-book"].endpoint, {
        head: {
            appName: APPNAME,
            appVer: APPVER,
            appSource: APP_SOURCE,
            osName: OSNAME,
            key: REACT_APP_API_HEADER_KEY || "",
            requestCode: "5PTrdBkV2",
        },
        body: {
            ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
            //getDataFromSession(SESSION_KEYS.CLIENT_CODE),,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getSingleOrderDetail = (exchange, exchangeType, exchOrderId) => {
    return ApiClient.post(Apis["get-single-order-detail"].endpoint, {
        ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
        //getDataFromSession(SESSION_KEYS.CLIENT_CODE),,
        Exch: exchange,
        ExchType: exchangeType,
        ExchOrderID: exchOrderId,
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getOrderUpdates = (dateTime, signal) => {
    return ApiClient.post(Apis["get-order-update"].endpoint, {
        head: {
            appName: APPNAME,
            appVer: APPVER,
            osName: OSNAME,
            key: REACT_APP_API_HEADER_KEY || "",
            requestCode: "5PGOU",
        },
        body: {
            ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
            //getDataFromSession(SESSION_KEYS.CLIENT_CODE),,
            LastOrderTime: dateTime,
        },
    }, Object.assign({ headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        } }, signal));
};
export const getChartToken = () => {
    return ApiClient.post(Apis["get-chart-token"].endpoint, null, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            //"Ocp-Apim-Subscription-Key": "98180aa74c694bbd92393f3bb8160573",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getChartTokenSocket = () => {
    return ApiClient.post(Apis["get-chart-token-socket"].endpoint, null, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            //"Ocp-Apim-Subscription-Key": "a4af51382266497bb5464d95fbb2017b",
            // Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
// export const getElasticSearchData = (searchString: string): Promise<any> => {
//   return ApiClient.post(
//     Apis["elastic-search"].endpoint,
//     // old ->    // {
//     //   search: searchString,
//     //   filter: "",
//     //   // orderby: "SearchOrder,SymbolOrder,Turnoverdata desc",
//     //   orderby: "SearchOrder, Expiry, SymbolOrder, Turnoverdata desc",
//     //   top: 10,
//     //   fuzzy: false,
//     //   suggesterName: "scrip-search2",
//     //   select:
//     //     "CPTypeText,StrikeRate,Name,DisplayName,Exch,ExchType,ScripCode,ExpiryDate,ShortName,FullName,DT,Turnoverdata",
//     // },
//     //new ->
//     {
//       search: searchString,
//       filter: "IndexId eq -1",
//       // orderby:
//       //   "SearchOrder,SymbolOrder,Expiry,StrikeRate,CPType,Turnoverdata desc, MarketCapital desc, FullName",
//       orderby:
//         "SymbolOrder,SearchOrder,Expiry,StrikeRate,CPType,Turnoverdata desc, MarketCapital desc, FullName",
//       top: 10,
//       fuzzy: false,
//       select:
//         "CPTypeText,StrikeRate,Name,DisplayName,Exch,ExchType,ScripCode,ExpiryDate,ShortName,FullName,DT,Turnoverdata",
//       suggesterName: "scrip-search2",
//       searchFields: "DisplayName",
//       searchMode: "any",
//       count: true,
//     },
//     {
//       headers: {
//         "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
//       },
//     }
//   );
// };
export const delBasket = (deleteBasketId) => {
    return ApiClient.post(Apis["delete-basket"].endpoint, {
        head: {
            appName: APPNAME,
            appVer: APPVER,
            osName: OSNAME,
            key: REACT_APP_API_HEADER_KEY || "",
            requestCode: "5PDelBSKT",
        },
        body: {
            BasketIDs: [
                {
                    BasketID: deleteBasketId,
                },
            ],
            ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
            //getDataFromSession(SESSION_KEYS.CLIENT_CODE),,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const GetActiveEquityByValue = () => {
    return ApiClient.post(Apis["get-active-equity"].endpoint, {}, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const renameBasket = (renameBasketId, nameOfBasket) => {
    return ApiClient.post(Apis["rename-basket"].endpoint, {
        head: {
            appName: APPNAME,
            appSource: APP_SOURCE,
            appVer: APPVER,
            osName: OSNAME,
            key: REACT_APP_API_HEADER_KEY || "",
            requestCode: "5PEditBSN",
        },
        body: {
            BasketID: renameBasketId,
            NewBasketName: nameOfBasket,
            ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
            //getDataFromSession(SESSION_KEYS.CLIENT_CODE),,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const adddToWatchlist = (props) => {
    return ApiClient.post(Apis["add-to-watchlist"].endpoint, {
        head: {
            appName: APPNAME,
            appVer: APPVER,
            key: REACT_APP_API_HEADER_KEY || "",
            osName: OSNAME,
            requestCode: "5PSaveMWV1",
        },
        body: {
            Clientcode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
            //getDataFromSession(SESSION_KEYS.CLIENT_CODE),,
            MWname: props.watchlistName,
            ClientLoginType: "0",
            Data: [
                {
                    Exch: props.Exch,
                    ExchType: props.ExchType,
                    ScripCode: `${props.ScripCode}`,
                    Action: "A",
                },
            ],
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const addToBasket = (body) => {
    return ApiClient.post(Apis["add-to-basket"].endpoint, {
        head: {
            appName: APPNAME,
            appSource: APP_SOURCE,
            appVer: APPVER,
            osName: OSNAME,
            key: REACT_APP_API_HEADER_KEY || "",
            requestCode: "5PAddOTB",
        },
        body: Object.assign({ ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE) }, body),
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const deleteVTTOrder = (orderId) => {
    return ApiClient.post(Apis["delete-vtt-order"].endpoint, {
        head: {
            appName: APPNAME,
            appVer: APPVER,
            osName: OSNAME,
            key: REACT_APP_API_HEADER_KEY || "",
            requestCode: "5PDeleteVTTO",
        },
        body: {
            //encrypt
            ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
            //getDataFromSession(SESSION_KEYS.CLIENT_CODE),,
            VTTOrderId: orderId,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getLogout = () => {
    return ApiClient.post(Apis["get-logout"].endpoint, {
        ClientCode: encrypt(getDataFromSession(SESSION_KEYS.CLIENT_CODE || "")),
        //getDataFromSession(SESSION_KEYS.CLIENT_CODE), || "")),
        MachineID: "BM4653-D-039377.loca",
        ServerIP: "192.168.88.41",
        ClientIP: "192.168.88.41",
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getMarketStatus = () => {
    const tempClientCode = (getDataFromSession(SESSION_KEYS.CLIENT_CODE) || "").toUpperCase();
    //For M2M market participation
    if (tempClientCode == "DEMOPRAS" || tempClientCode == "5PGOPI1") {
        //Dont call api and let after market status be N
        return new Promise((resolve, reject) => {
            resolve({ data: getMarketStatusDummyData() });
        });
    }
    return ApiClient.post(Apis["get-market-status"].endpoint, null, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const preOrderMarginCalculation = (orderId, coverPositions) => {
    return ApiClient.post(Apis["pre-order-margin-calculation"].endpoint, {
        head: {
            appName: APPNAME,
            appVer: APPVER,
            appSource: APP_SOURCE,
            osName: OSNAME,
            key: REACT_APP_API_HEADER_KEY || "",
            requestCode: "5PPreOrdMarCalBlkV2",
        },
        body: {
            ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
            //getDataFromSession(SESSION_KEYS.CLIENT_CODE),,
            BasketID: orderId,
            CoverPositions: coverPositions,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const cloneBasket = (basketId) => {
    return ApiClient.post(Apis["basket-clone"].endpoint, {
        head: {
            appName: APPNAME,
            appVer: APPVER,
            key: REACT_APP_API_HEADER_KEY || "",
            osName: OSNAME,
            requestCode: "5PCloneBSKT",
        },
        body: {
            ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
            //getDataFromSession(SESSION_KEYS.CLIENT_CODE),,
            BasketID: basketId,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const executeBasket = (basketId) => {
    return ApiClient.post(Apis["execute-basket"].endpoint, {
        head: {
            appName: APPNAME,
            appSource: APP_SOURCE,
            appVer: APPVER,
            key: REACT_APP_API_HEADER_KEY || "",
            osName: OSNAME,
            requestCode: "5PExecuteBSKT",
        },
        body: {
            ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
            //getDataFromSession(SESSION_KEYS.CLIENT_CODE),,
            BasketID: basketId,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const deleteOrderInBasket = (orderId) => {
    return ApiClient.post(Apis["delete-order-in-basket"].endpoint, {
        head: {
            appName: APPNAME,
            appVer: APPVER,
            key: REACT_APP_API_HEADER_KEY || "",
            osName: OSNAME,
            requestCode: "5PDeleteOIB",
        },
        body: {
            ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
            //getDataFromSession(SESSION_KEYS.CLIENT_CODE),,
            OrderIDs: [
                {
                    OrderID: orderId,
                },
            ],
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const modifyOrderInBasket = (requestBody) => {
    return ApiClient.post(Apis["modify-order-in-basket"].endpoint, {
        head: {
            appName: APPNAME,
            appVer: APPVER,
            key: REACT_APP_API_HEADER_KEY || "",
            osName: OSNAME,
            requestCode: "5PModifyOIB",
        },
        body: Object.assign({ ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE) }, requestBody),
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
            UserID: "ZHAaaQdSd6J",
            Password: "tmDDnp7hYaZ",
        },
    });
};
export const getOneLoginToken = () => {
    const body = {
        grant_type: "client_credentials",
        client_id: REACT_APP_ONELOGIN_TOKEN_CLIENT_ID,
        client_secret: REACT_APP_ONELOGIN_TOKEN_CLIENT_SECRET,
    };
    let formBody = [];
    for (const key in body) {
        const encodedKey = encodeURIComponent(key);
        const encodedValue = encodeURIComponent(body[key]);
        formBody.push(encodedKey + "=" + encodedValue);
    }
    formBody = formBody.join("&");
    return ApiClient.post(Apis["get-onelogin-token"].endpoint, formBody, {
        headers: {
            "content-type": "application/x-www-form-urlencoded",
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            // Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getMarketDepth20 = (token, exch, exchType) => {
    const marketDepthToken = getDataFromSession(SESSION_KEYS.MARKETDEPTHTOKEN) || "";
    return ApiClient.post(Apis["get-market-depth-20"].endpoint, { Token: token, Exch: exch, ExchType: exchType }, {
        headers: {
            authorization: `Bearer ${marketDepthToken}`,
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getMarketDepth5 = (token, exch, exchType) => {
    const marketDepthToken = getDataFromSession(SESSION_KEYS.MARKETDEPTHTOKEN) || "";
    return ApiClient.post(Apis["get-market-depth-5"].endpoint, { ScripCode: token, Exch: exch, ExchType: exchType }, {
        headers: {
            authorization: `Bearer ${marketDepthToken}`,
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getMarketDepthToken = () => {
    return ApiClient.post(Apis["get-market-depth-token"].endpoint, {}, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getRollover = () => {
    return ApiClient.get(Apis["get-rollover"].endpoint, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getDpHoldings = () => {
    return ApiClient.post(Apis["get-dpholding"].endpoint, {
        head: Object.assign(Object.assign({}, head), { requestCode: "5PDPHolding" }),
        body: { ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE) },
        //getDataFromSession(SESSION_KEYS.CLIENT_CODE), },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getScriptWiseDpholding = (scripCode, exchange, exchangeType, quantity) => {
    return ApiClient.post(Apis["get-script-wise-dpholding"].endpoint, {
        head: Object.assign(Object.assign({}, head), { requestCode: "5PGetScripWiseDPHolding" }),
        body: {
            ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
            // getDataFromSession(SESSION_KEYS.CLIENT_CODE),,
            Quantity: quantity,
            Exch: exchange,
            ExchType: exchangeType,
            ScripCode: scripCode,
            IPaddress: "",
            SourceApp: APP_SOURCE,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const generateBOPin = () => {
    return ApiClient.post(Apis["generate-bo-pin"].endpoint, {
        head: Object.assign(Object.assign({}, head), { requestCode: "5PGenerateBOPin" }),
        body: {
            ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
            //getDataFromSession(SESSION_KEYS.CLIENT_CODE),,
            ReqFlag: "G",
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getClientInfo = () => {
    return ApiClient.post(Apis["get-client-info"].endpoint, {
        //head handled at gateway
        body: {
            ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
            //getDataFromSession(SESSION_KEYS.CLIENT_CODE),,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const GetSellAuthorizationStatus = (edisReqList) => {
    return ApiClient.post(Apis["get-sell-authorization-status"].endpoint, {
        head: Object.assign(Object.assign({}, head), { requestCode: "5PGetSellAuthorizationStatus" }),
        body: {
            ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
            //getDataFromSession(SESSION_KEYS.CLIENT_CODE),,
            GetSellAuthorizationStatusReqList: edisReqList,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getCompanyDetail = (exchange, exchangeType, scripCode) => {
    return ApiClient.post(Apis["get-company-detail"].endpoint, {
        head: {
            appName: APPNAME,
            appSource: "20",
            appVer: APPVER,
            key: REACT_APP_API_HEADER_KEY || "",
            osName: OSNAME,
            requestCode: "5PComDtlPgV8",
        },
        body: {
            Exch: exchange,
            ExchType: exchangeType,
            ScripCode: scripCode,
            ClientLoginType: 1,
            Count: 1,
            RefreshRate: "H",
            ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
            //getDataFromSession(SESSION_KEYS.CLIENT_CODE),,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_API_HEADER_KEY2 || "",
            // Authorization: `Bearer ${getJwtToken()}`,
            UserID: "ZyT47UW2g56",
            Password: "H98qlU4Sn2",
        },
    });
};
export const setNotificationDetails = (notificationId) => {
    return ApiClient.post(Apis["set-notification-details"].endpoint, {
        ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
        //getDataFromSession(SESSION_KEYS.CLIENT_CODE),,
        ClientType: 0,
        DeviceOS: OSNAME,
        AppRegistrationID: notificationId,
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getLoginCheck = (notificationId) => {
    return ApiClient.post(Apis["login-check"].endpoint, {
        head: {
            appName: APPNAME,
            appVer: "1.1.0",
            key: "XYtGOuP5Qe4mXjSL5ZIaIarfILE9lqf0",
            osName: OSNAME,
            requestCode: "5PMarRQLC",
            LoginId: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
            //getDataFromSession(SESSION_KEYS.CLIENT_CODE),,
        },
        body: {
            RegistrationID: notificationId,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getExpirySymbolFuture = (exchange, symbol) => {
    return ApiClient.post(Apis["get-expiry-symbol-future"].endpoint, {
        body: {
            Exch: exchange,
            Symbol: symbol,
        },
        head: {
            appName: APPNAME,
            appVer: APPVER,
            key: REACT_APP_API_HEADER_KEY || "",
            osName: OSNAME,
            requestCode: "5PJanGEFSOV2",
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getIntraScreenerOptionExpiries = (pageType, scripType) => {
    return ApiClient.get(Apis["get-intraday-screener-option-expiries"].endpoint(pageType, scripType), {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            //"Ocp-Apim-Subscription-Key": "b12b0a98c2ce412e939df53482fd1a3d" || "",
            "api-key": REACT_APP_API_MARKETDATA_KEY,
            // Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getIntraScreenerFutureExpiries = () => {
    return ApiClient.get(Apis["get-intraday-screener-future-expiries"].endpoint, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            //"Ocp-Apim-Subscription-Key": "b12b0a98c2ce412e939df53482fd1a3d" || "",
            "api-key": REACT_APP_API_MARKETDATA_KEY,
            // Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getQuickOptionTradeApi = (symbol, expiry, trend) => {
    return ApiClient.post(Apis["get-quick-option-trade"].endpoint, {
        head: Object.assign(Object.assign({}, head), { appName: APPNAME, appVer: APPVER, appSource: "20", osName: OSNAME, key: REACT_APP_API_HEADER_KEY || "", requestCode: "5PGQOT" }),
        body: {
            ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
            //getDataFromSession(SESSION_KEYS.CLIENT_CODE),,
            Symbol: symbol,
            Trend: trend,
            Expiry: expiry,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getAdvisoryDetailsApi = (advisoryType, advisoryMode) => {
    return ApiClient.post(Apis["get-advisory-details"].endpoint, {
        ObjectName: "ListAdvisory",
        Token: advisoryToken,
        Parameters: {
            GetCount: "1",
            RowDisplayCount: "100",
            RowFrom: "0",
            mode: advisoryMode,
            segment: advisoryType,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getOiGainersApi = (date) => {
    return ApiClient.get(Apis["get-oi-gainers"].endpoint(date), {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getSectorPerformance = () => {
    return ApiClient.post(Apis["get-indices-v3"].endpoint, {
        Count: 0,
        Exch: "N",
        ClientLoginType: 0,
        LastRequestTime: "/Date(0)/",
        RefreshRate: "H",
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getIndexContributors = (companyName) => {
    return ApiClient.post(Apis["get-indices-detail-page"].endpoint, companyName, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
            // "Content-type": "text/plain",
            "Content-type": "application/json",
        },
    });
};
export const getElasticSearchDataNew = (searchString, skipData, filterString) => {
    return ApiClient.post(Apis["elastic-search-v2"].endpoint, {
        search: searchString,
        searchMode: "any",
        // filter: filterString
        //   ? `IndexId eq -1 and ${filterString}`
        //   : "IndexId eq -1",
        filter: filterString ? filterString : "",
        // orderby:
        //   "SearchOrder,SymbolOrder,Expiry,StrikeRate,CPType,Turnoverdata desc, MarketCapital desc, FullName",
        orderby: ELASTIC_SEARCH_ORDEBY_VALUE,
        top: 10,
        skip: skipData,
        select: "CPTypeText,StrikeRate,Name,DisplayName,Exch,ExchType,ScripCode,ExpiryDate,ShortName,FullName,DT,Turnoverdata,IndexId,MarketCapital,Instrument,Series",
        searchFields: "DisplayName,Name",
        count: true,
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            // Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getFutureIntradayBuildup = (symbol, expiry, interval) => {
    return ApiClient.get(Apis["get-future-intraday-buildup"].endpoint(symbol, expiry), {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            // Authorization: `Bearer ${getJwtToken()}`,
        },
        params: { interval: interval },
    });
};
export const getPredefinedStrategy = (strategyCode, symbol, expiry, { signal }) => {
    return ApiClient.post(Apis["predefined-strategy"].endpoint, {
        Strategy_Code: strategyCode,
        Symbol: symbol,
        MasterQty: "",
        Expiry: expiry,
        orderFor: "D",
        clientcode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
        // clientcode: "50240811",
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            // "Ocp-Apim-Subscription-Key": "a4af51382266497bb5464d95fbb2017b",
            Authorization: `Bearer ${getJwtToken()}`,
            // Authorization:
            //   "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6IjUwMjQwODExIiwicm9sZSI6IjEiLCJuYmYiOjE3MDM1NjIzOTMsImV4cCI6MTcxMTMzODM5MywiaWF0IjoxNzAzNTYyMzkzfQ.d7RsM_KV0q1pfawitClK5ajAeH1csv7G0X2JlL9z7VA",
        },
        signal,
    });
};
export const getStrategyBuilderPayoff = (symbol, requestArray) => {
    return ApiClient.post(Apis["strategy-builder-payoff"].endpoint(symbol), requestArray, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            //Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const multiStrikeOiApi = (symbol, { signal }) => {
    return ApiClient.get(Apis["multi-strike-oi"].endpoint(symbol), {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            "api-key": "uZadWV6x5CtUNnW-5p",
        },
        signal,
    });
};
export const getOptionsFromSymbol2 = (symbol, expiry) => {
    return ApiClient.post(Apis["get-options"].endpoint, {
        head: Object.assign(Object.assign({}, head), { requestCode: "5PJanGOFS" }),
        body: {
            Exch: "N",
            Symbol: symbol,
            ExpiryDate: expiry,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getMarginPlusDetails = () => {
    return ApiClient.post(Apis["margin-plus-status"].endpoint, {
        head: {
            appName: APPNAME,
            appVer: APPVER,
            key: REACT_APP_API_HEADER_KEY || "",
            osName: OSNAME,
            requestCode: "5PMarginPlus",
        },
        body: {
            ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const updateMarginPlusDetails = (value) => {
    return ApiClient.post(Apis["update-margin-plus-status"].endpoint, {
        head: {
            appName: APPNAME,
            appVer: APPVER,
            key: REACT_APP_API_HEADER_KEY || "",
            osName: OSNAME,
            requestCode: "5PUpdateMarginPlus",
        },
        body: {
            ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
            MTFOpted: value,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getClientProfile = () => {
    const clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
    return ApiClient.post(Apis["get-client-profile"].endpoint, clientCode, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
            "Content-Type": "application/json",
        },
        params: { ClientCode: clientCode },
    });
};
export const getBrokerageCalculation = (data, signal) => {
    // console.log(data, "data====");
    return ApiClient.post(Apis["get-brokerage-calculation-v2"].endpoint, {
        head: {
            appName: APPNAME,
            appVersion: APPVER,
            key: REACT_APP_API_HEADER_KEY || "",
            osName: OSNAME,
            requestCode: "5PUpdateMarginPlus",
            clientIP: "::1",
        },
        body: {
            clientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
            segment: data.segment,
            product: data.product,
            mode: data.mode,
            quantity: data.quantity ? data.quantity : 1,
            buyPrice: data.buyPrice,
            sellPrice: data.sellPrice,
            plan: data.plan,
            scripCode: data.scripCode,
            exchange: data.exchange,
        },
    }, Object.assign({ headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY2 || "",
            Authorization: `Bearer ${getJwtToken()}`,
        } }, signal));
};
export const getBrokerageCalculationApi = (segment, product, mode, quantity, buyPrice, sellPrice, plan, scripcode, exchange, location) => {
    return ApiClient.post(Apis["get-brokerage-calculation-v2"].endpoint, {
        head: {
            appName: APPNAME,
            appVersion: APPVER,
            key: REACT_APP_API_HEADER_KEY || "",
            osName: OSNAME,
            requestCode: "5PUpdateMarginPlus",
            clientIP: "::1",
        },
        body: {
            clientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
            segment: segment,
            product: product,
            mode: mode,
            quantity: quantity,
            buyPrice: buyPrice,
            sellPrice: sellPrice,
            plan,
            scripcode,
            exchange,
            location,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY2 || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
// export const getMarketDepthSocketToken = (): Promise<any> => {
//   return ApiClient.get(Apis["get-marketfeed-token"].endpoint, {
//     headers: {
//       "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
// Authorization: `Bearer ${getJwtToken()}`,
//     },
//   });
// };
export const getIndexContributorsFnoApi = (symbol) => {
    return ApiClient.get(Apis["get-index-contributors"].endpoint(symbol), {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            // Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const cashFilter = (exchange, exchangeType, scripCode) => {
    return ApiClient.post(Apis["cash-filter"].endpoint, {
        head: {
            appName: APPNAME,
            appSource: "20",
            appVer: APPVER,
            key: REACT_APP_API_HEADER_KEY || "",
            osName: OSNAME,
            requestCode: "5PCashFilterV1",
        },
        body: [
            {
                Exch: exchange,
                ExchType: exchangeType,
                ScripCode: scripCode,
            },
        ],
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
//smart api
let cancelToken;
export const getdefaultstrategies_Legs_Api = (symbol, expdate, strategyname, { signal }) => {
    // "symbol": "NIFTY",
    //   "expdate": "2023-01-25",
    //   "strategyname": "iron condor"
    return ApiClient.post(Apis["get-default-strategies-selection"].endpoint, {
        symbol,
        expdate,
        strategyname,
    }, {
        headers: {
            Authorization: "Bearer " + getLoginKey(),
            "Content-Type": "application/json",
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
        },
        signal,
    });
};
export const getstriketypelist_Api = (symbol) => {
    // "symbol": "NIFTY",
    //   "expdate": "2023-01-25",
    //   "strategyname": "iron condor"
    return ApiClient.post(Apis["strike-type-list"].endpoint, {
        symbol,
    }, {
        headers: {
            Authorization: "Bearer " + getLoginKey(),
            "Content-Type": "application/json",
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
        },
    });
};
export const getPredefinedAtAdd_Api = (data) => {
    return ApiClient.post(Apis["AT-add"].endpoint, Object.assign({}, data), {
        headers: {
            Authorization: "Bearer " + getLoginKey(),
            "Content-Type": "application/json",
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
        },
    });
};
export const getStrategiesDetails = (strategies_name) => {
    return ApiClient.post(Apis["AT_getdata"].endpoint, {
        StrategyName: strategies_name,
    }, {
        headers: {
            Authorization: "Bearer " + getLoginKey(),
            "Content-Type": "application/json",
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
        },
    });
};
export const getPayOffChart_Api = (data, { cancelToken }) => {
    return ApiClient.post(Apis["payoff-chart"].endpoint, Object.assign({}, data), {
        headers: {
            Authorization: "Bearer " + getLoginKey(),
            // Authorization:
            //   "Bearer aFYVEGj704le67BYdZhjlADZNOG1u1WA7XU1S9gefIN7A%2bHA7SLNEmQwtfzQYPvu",
            "Content-Type": "application/json",
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            // "Ocp-Apim-Subscription-Key": "a4af51382266497bb5464d95fbb2017b",
        },
        cancelToken,
    });
};
export const getSmartNetPosition = (signal) => {
    return ApiClient.post(Apis["get-smart-net-position"].endpoint, {}, Object.assign({ headers: {
            Authorization: "Bearer " + getLoginKey(),
            "Content-Type": "application/json",
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
        } }, signal));
};
export const getSmartNetPositionDepth = (strategyName, signal) => {
    return ApiClient.post(Apis["get-smart-net-position-depth"].endpoint, {
        strategyname: strategyName,
    }, Object.assign({ headers: {
            Authorization: "Bearer " + getLoginKey(),
            "Content-Type": "application/json",
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
        } }, signal));
};
export const getHistorySmartStrategies = (strategyName) => {
    return ApiClient.post(Apis["get-history-smart-strategies"].endpoint, {
        StrategyName: strategyName,
    }, {
        headers: {
            Authorization: "Bearer " + getLoginKey(),
            "Content-Type": "application/json",
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
        },
    });
};
export const setSquareOffSmartStrategies = (strategyName, type) => {
    return ApiClient.post(Apis["set-square-off-smart-strategies"].endpoint, {
        StrategyName: strategyName,
        Type: type,
    }, {
        headers: {
            Authorization: "Bearer " + getLoginKey(),
            "Content-Type": "application/json",
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
        },
    });
};
export const getLoginKey = () => {
    const localStorage_obj = getSmartApiKeyFromLocalStorage();
    return localStorage_obj.key;
    //return "1KziafcM%2fyly90u5kG%2fBvz4ehPThWCSzRu2hzYnHorKpm5zuCNN5GYUZa4GGbVFA"; //subodh login api for 06/03/2023
    // if (clientCode === "") {
    //   return "1KziafcM%2fyly90u5kG%2fBv3uA2sQX0g6TXHm2c5xj9SSmKbt949p80OyFilz93Dgc";
    // } else if (clientCode === "1") {
    //   return "1KziafcM%2fyly90u5kG%2fBv3uA2sQX0g6TXHm2c5xj9SSmKbt949p80OyFilz93Dgc";
    // } else if (clientCode === "2") {
    //   return "1KziafcM%2fyly90u5kG%2fBv3uA2sQX0g6TXHm2c5xj9SSmKbt949p80OyFilz93Dgc";
    // } else {
    //   return "1KziafcM%2fyly90u5kG%2fBv3uA2sQX0g6TXHm2c5xj9SSmKbt949p80OyFilz93Dgc";
    // }
};
// export const preOrdMarginCalculationBulkV3 = (
//   bulkDataPayload: bulkDataPayloadDataType[],
//   coverPositions: string
// ): Promise<any> => {
//   return ApiClient.post(
//     Apis["pre-order-margin-calculation-bulk"].endpoint,
//     {
//       head: {
//         appName: APPNAME,
//         appVer: APPVER,
//         // key: REACT_APP_API_HEADER_KEY || "",
//         key: "8eeee59bdab88bace6189d001f96487e",
//         osName: OSNAME,
//         requestCode: "5PPreOrdMarCalBlkV3",
//       },
//       body: {
//         // ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
//         ClientCode: "50240811",
//         CoverPositions: coverPositions,
//         OrdPreMarBulkData: bulkDataPayload,
//       },
//     },
//     {
//       headers: {
//         // "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
//         "Ocp-Apim-Subscription-Key": "a4af51382266497bb5464d95fbb2017b",
//         // Authorization: `Bearer ${getJwtToken()}`,
//         Authorization:
//           "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6IjUwMjQwODExIiwicm9sZSI6IjEiLCJuYmYiOjE2OTgwMzY4NzQsImV4cCI6MTcwNTgxMjg3NCwiaWF0IjoxNjk4MDM2ODc0fQ.TQPbv3tYpS--QlAsT6QHi9SxxypN0iMeB7U9eEBG1hM",
//       },
//     }
//   );
// };
// V3 Bulk margin
export const preOrdMarginCalculationBulkV3 = (bulkDataPayload, coverPositions, signal) => {
    return ApiClient.post(Apis["pre-order-margin-calculation-bulk"].endpoint, {
        head: {
            appName: APPNAME,
            appVer: APPVER,
            key: REACT_APP_API_HEADER_KEY || "",
            osName: OSNAME,
            requestCode: "5PPreOrdMarCalBlkV3",
        },
        body: {
            ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
            CoverPositions: coverPositions,
            OrdPreMarBulkData: bulkDataPayload,
        },
    }, Object.assign({ headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_API_HEADER_KEY2 || "",
            UserID: MARGIN_USERID,
            Password: MARGIN_PASSWORD,
            Authorization: `Bearer ${getJwtToken()}`,
            // Authorization:
            //   "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6IjUwMjQwODExIiwicm9sZSI6IjEiLCJuYmYiOjE3MDA5NjY4MDcsImV4cCI6MTcwODc0MjgwNywiaWF0IjoxNzAwOTY2ODA3fQ.mnXM8IuwwUJLX-zsYIsKlTwBLptICAmgWh8GxPmgcH0",
        } }, signal));
};
export const allowTMOOptionScrip = (exchange, exchangeType, scripCode) => {
    return ApiClient.post(Apis["allow-TMO-OptionScrip"].endpoint, {
        head: {
            appName: APPNAME,
            appSource: "20",
            appVer: APPVER,
            key: REACT_APP_API_HEADER_KEY || "",
            osName: OSNAME,
            requestCode: "5PAllowTMOOptionScrip",
        },
        body: {
            Exch: exchange,
            ExchType: exchangeType,
            ScripCode: scripCode,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const TMOScripList = (exchange, exchangeType) => {
    return ApiClient.post(Apis["TMOScripList"].endpoint, {
        head: {
            appName: APPNAME,
            appVer: APPVER,
            key: REACT_APP_API_HEADER_KEY || "",
            osName: OSNAME,
            requestCode: "5PTMOScrpLst",
        },
        body: {
            Exch: exchange,
            ExchType: exchangeType,
        },
    }, {
        headers: {
            "Content-Type": "application/json",
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
            UserID: "ZyT47UW2g56",
            Password: "H98qlU4Sn2",
        },
    });
};
export const getSessionTransferWrapper = () => {
    const { REACT_APP_ENV } = process.env;
    const clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
    const BodyKey = REACT_APP_ENV == "production"
        ? ALGO_SESSION_WRAPPER_KEY
        : ALGO_SESSION_WRAPPER_KEY;
    return ApiClient.post(Apis["session-transfer-wrapper"].endpoint, {
        head: {
            appName: APPNAME,
            appVer: APPVER,
            key: REACT_APP_API_HEADER_KEY,
            osName: OSNAME,
            requestCode: "5PSTWV",
        },
        body: {
            ClientCode: clientCode,
            Key: BodyKey,
        },
    }, {
        headers: {
            //"Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            UserID: "ZyT47UW2g56",
            Password: "H98qlU4Sn2",
            "Content-Type": "application/json",
            // Cookie: `5paisacookie=${cookie5p};JwtToken=${jwtValue}`,
            //Authorization: `Bearer ${jwtToken}`,
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
//webhook-token-api
export const getWebHookToken = (numOfDays) => {
    const clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
    return ApiClient.post(Apis["get-webhook-token"].endpoint, {
        head: {
            appName: "5PTRADE",
            appVer: "1.0",
            key: "8eeee59bdab88bace6189d001f96487e",
            osName: "Android",
            requestCode: "5PGST",
        },
        body: {
            ClientCode: clientCode,
            Key: "2cZCbIP2qqF8WlznfZsfI6G2aQGkiMOw",
            ExpiryInNoOfDays: numOfDays,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            //"Ocp-Apim-Subscription-Key": "a4af51382266497bb5464d95fbb2017b",
            UserID: "ZyT47UW2g56",
            Password: "H98qlU4Sn2",
        },
    });
};
export const getWebHookDetails = () => {
    const clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
    return ApiClient.post(Apis["get-webhook-details"].endpoint, {
        head: {
            appName: "5PTRADE",
            appVer: "1.0",
            key: "8eeee59bdab88bace6189d001f96487e",
            osName: "WEB",
            requestCode: "5PFWD",
        },
        body: {
            ClientCode: clientCode,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            //"Ocp-Apim-Subscription-Key": "a4af51382266497bb5464d95fbb2017b",
            UserID: "ZyT47UW2g56",
            Password: "H98qlU4Sn2",
        },
    });
};
//sso/session
export const getSsoSessionApi = (access_token) => {
    const { REACT_APP_ENV } = process.env;
    let jwtValue = getDataFromSession(SESSION_KEYS.JWTTOKEN);
    const clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
    if (jwtValue) {
        jwtValue = jwtValue.replace("JwtToken=", "").trim();
    }
    // const Ocp_Apim_Key =
    //   REACT_APP_ENV == "production"
    //     ? "a8ed3b7ead504fa8903d9c7e0d23bc61"
    //     : "2284d4215515451ca7266097726d8097";
    return ApiClient.post(Apis["sso-session"].endpoint, {
        clientid: clientCode,
        accesstoken: access_token,
    }, {
        headers: {
            Authorization: "Bearer yDKlycmwWxSYz+N8d6fziL1AGiUt6427sOCupDnhirc=",
            "Content-Type": "application/json",
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
        },
    });
};
export const getHoldings = (signal) => {
    return ApiClient.post(Apis["get-holding"].endpoint, {
        head: Object.assign(Object.assign({}, head), { requestCode: "5PHoldingV7" }),
        body: {
            ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
        },
    }, Object.assign({ headers: {
            Cookie: getDataFromSession(SESSION_KEYS.REQUEST_COOKIE),
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
        } }, signal));
};
export const getIndicesMasterNew = () => {
    return ApiClient.post(Apis["get-indices-master"].endpoint, {}, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getIndicesMasterV3 = (exch) => {
    return ApiClient.post(Apis["get-indices-master-v3"].endpoint, {
        Count: 0,
        Exch: exch,
        ClientLoginType: 0,
        LastRequestTime: "/Date(0)/",
        RefreshRate: "H",
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            UserID: "ZyT47UW2g56",
            Password: "H98qlU4Sn2",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getPledgeRequest = () => {
    return ApiClient.post(Apis["get-pledge-request"].endpoint, {
        head: Object.assign(Object.assign({}, head), { requestCode: "5PGPRequest" }),
        body: {
            ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getUnpledgeRequest = () => {
    return ApiClient.post(Apis["get-unpledge-request"].endpoint, {
        head: Object.assign(Object.assign({}, head), { requestCode: "5PGUPRequest" }),
        body: {
            ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const executeOrderApICDSLMP = (requestData) => {
    return ApiClient.post(Apis["holding-CDSL-authorization"].endpoint, {
        head: {
            appName: APPNAME,
            appVer: APPVER,
            osName: OSNAME,
            key: REACT_APP_API_HEADER_KEY || "",
            requestCode: "5PPostDataToCDSLMP",
        },
        body: {
            ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
            //getDataFromSession(SESSION_KEYS.CLIENT_CODE),,
            IPaddress: "172.26.20.66",
            SourceApp: REACT_APP_SOURCE_APP_HOLDING,
            isindtls: requestData,
            key: REACT_APP_API_HEADER_KEY,
            osName: OSNAME,
            appSource: "20",
            requestCode: "5PSetInd",
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_MARGIN_API_GATEWAY_KEY || "",
            UserID: "ZyT47UW2g56",
            Password: "H98qlU4Sn2",
        },
    });
};
export const saveUnpledgeRequest = (body) => {
    return ApiClient.post(Apis["save-unpledge-request"].endpoint, {
        head: {
            appName: APPNAME,
            appVer: APPVER,
            appSource: APP_SOURCE,
            osName: OSNAME,
            key: REACT_APP_API_HEADER_KEY || "",
            requestCode: "5PSURequest",
        },
        body: {
            ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
            Data: body,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_MARGIN_API_GATEWAY_KEY || "",
            // Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const setMasterIndices = (lstofIndices) => {
    // const key = localStorage.getItem("auth_key") || "";
    const clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
    return ApiClient.post(Apis["set-master-indices"].endpoint, {
        head: {
            appName: APPNAME,
            appVer: APPVER,
            key: REACT_APP_API_HEADER_KEY,
            osName: OSNAME,
            appSource: "20",
            requestCode: "5PSetInd",
        },
        body: {
            ClientCode: clientCode,
            Count: 2,
            lstofIndices: lstofIndices,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            // Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getCompanyDetailNew = (exchange, exchangeType, scripCode) => {
    return ApiClient.post(Apis["get-company-detail-tradeStation"].endpoint, {
        head: {
            appName: APPNAME,
            appSource: "20",
            appVer: APPVER,
            key: REACT_APP_API_HEADER_KEY || "",
            osName: OSNAME,
            requestCode: "5PComDtlPgV7",
        },
        body: {
            Exch: exchange,
            ExchType: exchangeType,
            ScripCode: scripCode,
            ClientLoginType: 1,
            Count: 1,
            RefreshRate: "H",
            ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
            //getDataFromSession(SESSION_KEYS.CLIENT_CODE),,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_API_HEADER_KEY2 || "",
            // Authorization: `Bearer ${getJwtToken()}`,
            UserID: "ZyT47UW2g56",
            Password: "H98qlU4Sn2",
        },
    });
};
export const getFutOptStockDetails = (symbol) => {
    return ApiClient.get(Apis["get-fo-stock-details"].endpoint(symbol), {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            //"Ocp-Apim-Subscription-Key": "a4af51382266497bb5464d95fbb2017b" || "",
            Authorization: `Basic aW5kaWFpbmZvbGluZVw1cGFuZHJvaWQ6MnhxUzV2L1g5Og==`,
        },
    });
};
// MWPL Ban list API
export const getMWPLBanListApi = (signal) => {
    return ApiClient.get(Apis["get-mwpl-banlist"].endpoint, Object.assign({ headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_API_HEADER_KEY2 || "",
            UserID: "ZyT47UW2g56",
            Password: "H98qlU4Sn2",
            Authorization: `Bearer ${getJwtToken()}`,
        } }, signal));
};
export const getStrategyBuilderPayoffNew = (symbol, daysToExpiry, expiry, minStrike, maxStrike, requestArray, signal) => {
    return ApiClient.post(Apis["strategy-builder-payoff-new"].endpoint(symbol, daysToExpiry, expiry, minStrike, maxStrike), requestArray, Object.assign({ headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            "Content-type": "application/json",
            "api-key": "uZadWV6x5CtUNnW-5p",
            Authorization: `Bearer ${getJwtToken()}`,
            clientid: "NTAyMjM4NzA=",
        } }, signal));
};
export const notificationApi = (LastRequestedTime) => {
    const clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
    return ApiClient.post(Apis["get-notification"].endpoint, {
        head: {
            appName: APPNAME,
            appSource: APP_SOURCE,
            appVer: APPVER,
            osName: OSNAME,
            key: REACT_APP_API_HEADER_KEY || "",
            requestCode: "5PNCV5",
        },
        body: {
            ClientCode: clientCode,
            LastRequestedTime: "/Date(" + LastRequestedTime + ")/",
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            UserID: "ZyT47UW2g56",
            Password: "H98qlU4Sn2",
            // Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6IjUwMjIzODcwIiwicm9sZSI6IjEiLCJuYmYiOjE2OTMyMDE5MTEsImV4cCI6MTcwMDk3NzkxMSwiaWF0IjoxNjkzMjAxOTExfQ.2RRWpPi2zdvNopGoahK_I2OtbInLybV-ctofd3cZ_s0`,
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getMFMargin = () => {
    return ApiClient.post(Apis["get-mf-margin"].endpoint, {
        head: {
            appName: "MFServices",
            appSource: "20",
            appVer: APPVER,
            key: "9SATBVDWEXGZH2J4M5N6Q8R9SA",
            osName: OSNAME,
            requestCode: "MBRQLO01",
        },
        body: {},
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            // "Ocp-Apim-Subscription-Key": "a4af51382266497bb5464d95fbb2017b",
            Authorization: `Bearer ${getJwtToken()}`,
            // Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6IjUwMjQwODExIiwicm9sZSI6IjEiLCJuYmYiOjE3MDEyMjI2NTksImV4cCI6MTcwODk5ODY1OSwiaWF0IjoxNzAxMjIyNjU5fQ.eGNOnCXhWaavyM2HraRnU_-KzeSAb6S7hXLrV-JWyUM`,
        },
    });
};
export const getMarginV11 = () => {
    const clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
    return ApiClient.post(Apis["get-margin-v11"].endpoint, {
        head: {
            appName: "5PTRADE",
            appSource: "20",
            appVer: "1.0",
            key: REACT_APP_API_HEADER_KEY || "",
            osName: "Web",
            requestCode: "5PMarginV11",
        },
        body: {
            ClientCode: clientCode,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_API_HEADER_KEY2 || "",
            // "Ocp-Apim-Subscription-Key": "df55f1c3f19646bb9cf803d1dafe316b",
            UserID: "ZyT47UW2g56",
            Password: "H98qlU4Sn2",
            // Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6IjUwMjQwODExIiwicm9sZSI6IjEiLCJuYmYiOjE3MDEyMjI2NTksImV4cCI6MTcwODk5ODY1OSwiaWF0IjoxNzAxMjIyNjU5fQ.eGNOnCXhWaavyM2HraRnU_-KzeSAb6S7hXLrV-JWyUM`,
            // Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const setPriceAlert = (requestBody) => {
    return ApiClient.post(Apis["set-Price-Alert"].endpoint, {
        head: {
            appName: APPNAME,
            appVer: APPVER,
            key: REACT_APP_API_HEADER_KEY || "",
            appSource: APP_SOURCE,
            osName: OSNAME,
            requestCode: "5PDecPAV3",
        },
        body: requestBody,
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_API_HEADER_KEY2 || "",
            UserID: REACT_APP_API_USER_ID1,
            Password: REACT_APP_API_PASSWORD1,
        },
    });
};
export const getPriceAlertList = () => {
    const clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
    return ApiClient.post(Apis["get-Price-Alert"].endpoint, {
        head: {
            appName: APPNAME,
            appVer: APPVER,
            key: REACT_APP_API_HEADER_KEY || "",
            appSource: APP_SOURCE,
            osName: OSNAME,
            requestCode: "5PDecGPAV2",
        },
        body: { ClientId: clientCode },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_API_HEADER_KEY2 || "",
            UserID: REACT_APP_API_USER_ID1,
            Password: REACT_APP_API_PASSWORD1,
        },
    });
};
export const modifyPriceAlert = (requestBody) => {
    return ApiClient.post(Apis["modify-Price-Alert"].endpoint, {
        head: {
            appName: APPNAME,
            appSource: APP_SOURCETRADESTATION,
            appVer: APPVER,
            key: REACT_APP_API_HEADER_KEY || "",
            osName: OSNAME,
            requestCode: "5PDecMPAV2",
        },
        body: requestBody,
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_API_HEADER_KEY2 || "",
            UserID: REACT_APP_API_USER_ID1,
            Password: REACT_APP_API_PASSWORD1,
        },
    });
};
export const deletePriceAlert = (alertId) => {
    return ApiClient.post(Apis["delete-Price-Alert"].endpoint, {
        head: {
            appName: APPNAME,
            appVer: APPVER,
            key: REACT_APP_API_HEADER_KEY || "",
            appSource: APP_SOURCETRADESTATION,
            osName: OSNAME,
            requestCode: "5PDecDPA",
        },
        body: {
            AlertID: alertId,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_API_HEADER_KEY2 || "",
            UserID: REACT_APP_API_USER_ID1,
            Password: REACT_APP_API_PASSWORD1,
        },
    });
};
export const GetBODHolding = (requestBody) => {
    return ApiClient.post(Apis["get-BOD-Holding"].endpoint, {
        head: {
            appName: APPNAME,
            appVer: APPVER,
            key: REACT_APP_API_HEADER_KEY || "",
            appSource: APP_SOURCETRADESTATION,
            osName: OSNAME,
            requestCode: "GetBODHolding",
        },
        body: requestBody,
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_API_HEADER_KEY2 || "",
            UserID: REACT_APP_API_USER_ID1,
            Password: REACT_APP_API_PASSWORD1,
        },
    });
};
export const getStrangleChartData = (index, strikePrice1, strikeprice2) => {
    return ApiClient.get(Apis["get-strangle-data"].endpoint(index, strikePrice1, strikeprice2), {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_MARGIN_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
            "api-key": "uZadWV6x5CtUNnW-5p",
        },
    });
};
export const getStraddleChartData = (index, strikePrice1) => {
    return ApiClient.post(Apis["get-straddle-data"].endpoint(index), strikePrice1, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_MARGIN_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
            "api-key": "uZadWV6x5CtUNnW-5p",
        },
    });
};
export const getStratZyActiveSignal = () => {
    return ApiClient.get(Apis["get-stratzy-active-signal"].endpoint, {
        headers: {
            "partner-authorization": "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJicm9rZXIiOiI1UEFJU0EiLCJpYXQiOjE2OTkyOTI3Mzg4ODd9.E6ekZH4jG7LLs6Lkm2d2txVCq55zZ3RBYNr9UEu-h64",
            //"Ocp-Apim-Subscription-Key": "a8c48d8b5ecf414796a24266472c2bff",
            "Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
        },
    });
};
export const getClientInfoApi = () => {
    const clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
    return ApiClient.post(Apis["get-client-info-v1"].endpoint, {
        head: {
            appName: "5P",
            appVer: "1.0",
            key: "kahdAjhfdsd423jkoi3frDFD3vbxvzyXZ4S4dF",
            osName: "Web",
        },
        body: {
            ClientCode: clientCode,
        },
    }, {
        headers: {
            "ocp-apim-subscription-key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
            // "ocp-apim-subscription-key": "a4af51382266497bb5464d95fbb2017b",
            // Authorization:
            //   "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6IjUwMjQwODExIiwicm9sZSI6IjEiLCJuYmYiOjE3MDk3MTc3ODEsImV4cCI6MTcxNzQ5Mzc4MSwiaWF0IjoxNzA5NzE3NzgxfQ.1rC8G8b4wUOw3PRupb0A9R7qqyribmta8odqfcUjyDM",
        },
    });
};
export const pushSegmentApi = (dpAccountNo, incomeSlab, checkSum) => {
    const clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
    return ApiClient.post(Apis["push-segment-v1"].endpoint, {
        head: {
            IPAddress: "192.168.10.100",
            AppSource: APP_SOURCE_SEGMENT_API,
            ChecksumValue: checkSum,
        },
        body: {
            typeOfModification: 1,
            clientCode: clientCode,
            dpAccountNo: dpAccountNo,
            incomeSlab: incomeSlab,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_ACTIVATE_SEGMENT_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
            // Authorization:
            //   "Barear eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6IjUwMjQwODExIiwicm9sZSI6IjEiLCJuYmYiOjE3MDk3MTc3ODEsImV4cCI6MTcxNzQ5Mzc4MSwiaWF0IjoxNzA5NzE3NzgxfQ.1rC8G8b4wUOw3PRupb0A9R7qqyribmta8odqfcUjyDM",
        },
    });
};
export const getClientModificationStatus_V1 = (checkSum, token) => {
    const clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
    return ApiClient.post(Apis["get-client-modification-status"].endpoint, {
        head: {
            IPAddress: "192.168.10.100",
            AppSource: APP_SOURCE_SEGMENT_API,
            ChecksumValue: checkSum,
        },
        body: {
            clientCode: clientCode,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_ACTIVATE_SEGMENT_KEY || "",
            Authorization: `Bearer ${token}`,
            // Authorization:
            //   "Barear eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6IjUwMjQwODExIiwicm9sZSI6IjEiLCJuYmYiOjE3MDk3MTc3ODEsImV4cCI6MTcxNzQ5Mzc4MSwiaWF0IjoxNzA5NzE3NzgxfQ.1rC8G8b4wUOw3PRupb0A9R7qqyribmta8odqfcUjyDM",
        },
    });
};
export const getJWTToken = (checkSum) => {
    const clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
    return ApiClient.post(Apis["get-jwtToken"].endpoint, {
        head: {
            IPAddress: "192.168.10.100",
            AppSource: APP_SOURCE_SEGMENT_API,
            ChecksumValue: checkSum,
        },
        body: {
            clientCode: clientCode,
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_ACTIVATE_SEGMENT_KEY || "",
            // Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getMaxPainChartData = (symbol, { signal }) => {
    return ApiClient.get(Apis["get-max-pain-data"].endpoint(symbol), {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_MARGIN_API_GATEWAY_KEY || "",
            "api-key": "uZadWV6x5CtUNnW-5p",
            // Authorization: `Bearer ${getJwtToken()}`,
        },
        signal,
    });
};
export const getAdvisoryBasketDetailsApi = (advisoryMode) => {
    return ApiClient.post(Apis["get-advisory-basket-details"].endpoint, {
        ObjectName: "ListAdvisory",
        Token: advisoryToken,
        Parameters: {
            mode: advisoryMode,
            // GetCount: "1",
            // RowDisplayCount: "100",
            // RowFrom: "0",
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_GATEWAY_CRM_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const getAdvisoryBasketHistoryApi = (advisoryMode) => {
    return ApiClient.post(Apis["get-advisory-basket-details"].endpoint, {
        ObjectName: "ListAdvisory",
        Token: advisoryToken,
        Parameters: {
            mode: advisoryMode,
            // GetCount: "1",
            // RowDisplayCount: "100",
            // RowFrom: "0",
        },
    }, {
        headers: {
            "Ocp-Apim-Subscription-Key": REACT_APP_GATEWAY_CRM_KEY || "",
            Authorization: `Bearer ${getJwtToken()}`,
        },
    });
};
export const delete5PaisaCookieCookieAndSetNewCookie = () => {
    const raw = JSON.stringify({
        CookieName: "5paisacookie",
    });
    return ApiClient.post(Apis["delete-cookie"].endpoint, raw, {
        headers: {
            authorization: "CC4AF799EE1DEC6E648F6C2B4DDB1",
            "content-type": "application/json",
        },
    });
};
export const getGuestLoginCheck = (signal) => {
    return ApiClient.post(Apis["get-guest-login-check"].endpoint, {
        head: {
            appName: "5PTRADE",
            appVer: "1.0",
            key: "8eeee59bdab88bace6189d001f96487e",
            osName: "Android",
            requestCode: "5PGuestUserLoginCheck",
        },
        body: {
            LoginID: "50197014",
            DeviceID: "BM4653-D-039377.local.indiainfoline.com",
            UserType: "REGISTERUSER",
        },
    }, Object.assign({ headers: {
            UserID: "ZHAaaQdSd6J",
            Password: "tmDDnp7hYaZ",
        } }, signal));
};
export const extractCookieFromHeader = () => {
    return ApiClient.post(Apis["extract-cookie-from-header"].endpoint, {
        head: {
            appName: APPNAME,
            appSource: "20",
            appVer: APPVER,
            key: REACT_APP_API_HEADER_KEY || "",
            osName: OSNAME,
            requestCode: "5PComDtlPgV7",
        },
        body: {
            ClientLoginType: 1,
            Count: 1,
            RefreshRate: "H",
            ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
        },
    }, {
        headers: {
            UserID: "ZyT47UW2g56",
            Password: "H98qlU4Sn2",
        },
    });
};
export const getOptionsData = (symbol) => {
    return ApiClient.get(Apis["get-options-data"].endpoint(symbol), {
        headers: {},
    });
};
export const getOptionsFutData = (symbol) => {
    return ApiClient.get(Apis["get-options-fut-data"].endpoint(symbol), {
        headers: {},
    });
};
export const getMarketFeedV4 = (body, signal) => {
    return ApiClient.post(Apis["get-mf-v4"].endpoint, Object.assign({}, body), Object.assign(Object.assign({ headers: {
            //"Ocp-Apim-Subscription-Key": REACT_APP_TRADE_API_GATEWAY_KEY || "",
            UserID: "ZyT47UW2g56",
            Password: "H98qlU4Sn2",
        } }, signal), { withCredentials: true }));
};
